import { Trial, useSendExaminationReminderNotificationMutation } from "@generated/graphql";
import { Button, ButtonProps } from "@mui/material";
import { ExaminationItem } from "components/ExaminationList/types";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { getIsTrialEnableForReminder } from "helpers/trials.helper";
import { MouseEvent, useContext } from "react";

interface TrialsReminderSendButtonProps {
  buttonProps?: ButtonProps;
  examination: Pick<ExaminationItem, "id" | "trials">;
  trial?: Pick<Trial, "id" | "status">;
}

const TrialsReminderSendButton = ({ buttonProps, examination, trial }: TrialsReminderSendButtonProps) => {
  const { disabled, ...restButtonProps } = buttonProps || {};
  const { addToast } = useContext(ToastContext);

  const getTrialIds = () => {
    if (trial?.id) return [trial.id];
    if (examination.trials?.length) return examination.trials.map((trialItem) => trialItem.id);
    return undefined;
  };

  const [sendExaminationReminderNotification, { loading }] = useSendExaminationReminderNotificationMutation({
    variables: { input: { id: examination.id, trialIds: getTrialIds() } },
  });

  const onError = (err: unknown) => {
    addToast({ text: "Ошибка отправки напоминания", type: ToastTypeEnum.ERROR });

    // eslint-disable-next-line no-console
    console.log("err", err);
  };

  const handleRemindersSendClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    sendExaminationReminderNotification()
      .then(({ data, errors }) => {
        if (data?.sendExaminationReminderNotification) {
          addToast({ text: "Напоминание отправлено кандидату", type: ToastTypeEnum.SUCCESS });
        } else {
          onError(errors);
        }
      })
      .catch(onError);
  };

  return (
    <Button
      onClick={handleRemindersSendClick}
      disabled={loading || (trial && !getIsTrialEnableForReminder(trial))}
      {...restButtonProps}>
      Отправить
    </Button>
  );
};

export default TrialsReminderSendButton;
